import { render, staticRenderFns } from "./TrxMatchEdit.vue?vue&type=template&id=76010d7c&"
import script from "./TrxMatchEdit.vue?vue&type=script&lang=js&"
export * from "./TrxMatchEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports